import {
  SERVER_OFF,
  SERVER_ON,
  SOCKET_READY,
  SET_REG_SYMBOL,
  UNSET_REG_SYMBOL,
  RECEIVE_1101,
  RECEIVE_3211,
  ListAccount,
  DefaultAccount,
  NewOrder,
  PurchasePower,
  StockBalance,
  OrderList,
  CancelOrder,
  EditOrder,
  CashBalance,
  ShareBalance,
  getAvailStockList,
  getPositions,
  ListOrder,
  GetMatchOrder,
  Event,
  getSymbolInfo,
  RECEIVE_3220,
} from './constants';

const initialState = {
  receive1101: {},
  receive3211: {},
  receive3220: {},
  // channelStatus: 'off',
  serverStatus: 'unknown',
  socketReady: false,
  regPrivate: 'unknown',
  reRegister: false,

  listAccount: null,
  defaultAccount: null,
  newOrder: null,
  purchasePower: null,
  stockBalance: null,
  orderList: null,
  listOrder: null,
  getMatchOrder: null,
  cancelOrder: null,
  editOrder: null,

  cashBalance: null,
  shareBalance: null,
  availStockList: null,
  positions: null,
  event: null,
  regSym: null,

  algoSignal: false,
  receiveSignal: null,
  algoIndex: null,
  algoStock: null,
  algoCache: null,
  algoIChart: null,
  algoSChart: null,
};

const reducer = function socketReducer(state = initialState, action) {
  switch (action.type) {
    /***************************** LOG_OUT ***************************/
    case 'LOG_OUT':
    case 'CLIENT_UNSET':
    case 'INVALID_SESSION':
      return {
        ...state,
        listAccount: null,
        defaultAccount: null,
        newOrder: null,
        purchasePower: null,
        stockBalance: null,
        orderList: null,
        listOrder: null,
        getMatchOrder: null,
        cancelOrder: null,
        editOrder: null,
        cashBalance: null,
        positions: null,
        shareBalance: null,
        availStockList: null,
        event: null,
      };

    /***************************** PRIVATE ***************************/
    case ListAccount:
      return { ...state, listAccount: action.resData };

    case DefaultAccount:
      return { ...state, defaultAccount: action.resData };

    case NewOrder:
      return { ...state, newOrder: action.resData };

    case PurchasePower:
      return { ...state, purchasePower: action.resData };

    case StockBalance:
      return { ...state, stockBalance: action.resData };

    case OrderList:
      return { ...state, orderList: action.resData };

    case ListOrder:
      return { ...state, listOrder: action.resData };

    case GetMatchOrder:
      return { ...state, getMatchOrder: action.resData };

    case CancelOrder:
      return { ...state, cancelOrder: action.resData };

    case EditOrder:
      return { ...state, editOrder: action.resData };

    case CashBalance:
      return { ...state, cashBalance: action.resData };

    case getPositions:
      return { ...state, positions: action.resData };

    case ShareBalance:
      return { ...state, shareBalance: action.resData };

    case getAvailStockList:
      return { ...state, availStockList: action.resData };

    case Event:
      return { ...state, event: action.resData };

    case getSymbolInfo:
      // console.log(action.resData)
      const _symbolInfo =
        action.resData && action.resData.list && action.resData.list.length > 0
          ? action.resData.list[0]
          : null;
      const _symbolMargin =
        action.resData && action.resData.dataMargin
          ? action.resData.dataMargin
          : null;
      return { ...state, symbolInfo: _symbolInfo, symbolMargin: _symbolMargin };

    /***************************** PUBLIC ***************************/
    case SET_REG_SYMBOL:
      return {
        ...state,
        regSym: state.regSym
          ? state.regSym.concat(',').concat(action.symbol)
          : action.symbol,
      };

    case 'RE_REGISTER':
      return {
        ...state,
        reRegister: action.resData,
      };

    case UNSET_REG_SYMBOL:
      return { ...state, regSym: '' };

    case SERVER_OFF:
      return { ...state, serverStatus: 'off' };

    case SERVER_ON:
      return { ...state, serverStatus: 'on' };

    case 'REGISTER_OK':
      return { ...state, regPrivate: 'ok', serverStatus: 'on' };

    case 'REGISTER_NOT_OK':
      return { ...state, regPrivate: 'not', serverStatus: 'off' };

    case SOCKET_READY:
      return { ...state, socketReady: true, serverStatus: 'on' };

    case RECEIVE_1101:
      return { ...state, receive1101: action.resData };

    case RECEIVE_3211:
      return { ...state, receive3211: action.resData };

    case RECEIVE_3220:
      return { ...state, receive3220: action.resData };

    case 'ALGO_SIGNAL_READY':
      return { ...state, algoSignal: action.resData };

    case 'ALGO_SIGNAL_RECEIVE':
      return { ...state, receiveSignal: action.resData };

    case 'ALGO_INDEX_RECEIVE':
      return { ...state, algoIndex: action.resData };

    case 'ALGO_STOCK_RECEIVE':
      return { ...state, algoStock: action.resData };

    case 'ALGO_CACHE_RECEIVE':
      return { ...state, algoCache: action.resData };

    case 'ALGO_INDEX_CHART':
      return { ...state, algoIChart: action.resData };

    case 'ALGO_STOCK_CHART':
      return { ...state, algoSChart: action.resData };

    default:
      return state;
  }
};

export default reducer;
